var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4073 18.9296L16.9969 14.7029C18.0587 13.3482 18.6319 11.6993 18.63 10.005C18.63 5.67723 14.9559 2.15625 10.44 2.15625C5.92406 2.15625 2.25 5.67723 2.25 10.005C2.25 14.3328 5.92406 17.8538 10.44 17.8538C12.208 17.8556 13.9286 17.3063 15.3422 16.2887L19.7527 20.5154C19.9759 20.7066 20.2671 20.8087 20.5664 20.8007C20.8658 20.7927 21.1505 20.6751 21.3623 20.4722C21.574 20.2693 21.6967 19.9964 21.7051 19.7095C21.7135 19.4226 21.6069 19.1436 21.4073 18.9296ZM4.59 10.005C4.59 8.89619 4.9331 7.81228 5.5759 6.89033C6.21871 5.96839 7.13235 5.24982 8.2013 4.8255C9.27025 4.40118 10.4465 4.29015 11.5813 4.50647C12.7161 4.72279 13.7584 5.25673 14.5766 6.04078C15.3947 6.82483 15.9519 7.82377 16.1776 8.91127C16.4033 9.99878 16.2875 11.126 15.8447 12.1504C15.4019 13.1748 14.6521 14.0504 13.6901 14.6664C12.7281 15.2824 11.597 15.6113 10.44 15.6113C8.88905 15.6095 7.40217 15.0182 6.30548 13.9672C5.2088 12.9163 4.59186 11.4913 4.59 10.005Z",
    fill: "#FFFAFA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.94e2808f56cb2e1110351f2054810308.svg";
export { ForwardRef as ReactComponent };